import { v5 as uuidv5 } from 'uuid';
export default function generateFormEventId(comments, fromEmailAddress, listingId, ownerId) {
  const entryInformation = {
    emailAddress: fromEmailAddress,
    listingId,
    comments,
    ownerId,
    date: new Date().toDateString()
  };
  const hashedString = JSON.stringify(entryInformation);
  return uuidv5(hashedString, uuidv5.URL);
}